const successStatus = 'checkout_complete';
const checkoutSelector = '.Single__checkout';
const protectedClassName = 'Single__protected';
let $window;

function handlePostMessage(eventData) {
  if (typeof eventData === 'string' && eventData.indexOf(successStatus) > -1) {
    let checkoutData;
    try {
      checkoutData = JSON.parse(eventData);
    }
    catch (error) {
      console.error(error);
    }
    if (checkoutData && checkoutData.status === successStatus) {
      handleCheckoutSuccess(checkoutData);
    }
  }
}

function handleCheckoutSuccess(checkoutData) {
  $window.trigger('mediaconnect:lockup', checkoutData);
  $window.on('mediaconnect:paywall_was_hidden', () => {
    $('html, body').animate({
      scrollTop: $('.mediaconnect-protected-content').offset().top - 200,
    }, 500);
  });
}

function setupIframeResize(e, parentNode) {
  if (typeof window.iFrameResize !== 'undefined') {
    // Cross domain resizing
    const $iframe = $(parentNode).find('.Paywall__embed');
    if ($iframe.length) {
      window.iFrameResize({}, $iframe.get(0));
    }
  }
}

function setupCheckout() {
  $window.on('mediaconnect:lockup', () => {
    $(`${checkoutSelector}__confirmation`).show();
    $(`${checkoutSelector}__embed`).hide();
    $('html, body').animate({
      scrollTop: $(checkoutSelector).offset().top - 200,
    }, 500);
    if (!window.location.href.includes('?status=ok')) {
      window.history.pushState({}, '', window.location.pathname + '?status=ok');
    }
  });
}

setTimeout(() => {
  if (document.querySelector('.Paywall__embed[data-cookieconsent="preferences"]')) {
    const k = document.querySelector('#klarna-unsupported-page');
    k.style.display = 'block';
    alert(k);
  }
  
}, 5000);

export default function() {
  $window = $(window);

  $window.on('mediaconnect:paywall_was_shown', setupIframeResize);

  $window.on('mediaconnect:paywall_was_hidden', () => $(`.${protectedClassName}`).removeClass(protectedClassName));

  const $checkout = $(checkoutSelector);
  if ($checkout.length) {
    setupCheckout();
    setupIframeResize({}, $checkout.get(0));
  }

  $window.on('message onmessage', function(e) {
    handlePostMessage(e.originalEvent.data);
  });
}



// WEBPACK FOOTER //
// ./scripts/components/paywall.js